export default __webpack_public_path__ + "static/media/to_delete5.fee97cd6.png";